module.exports={"Star Rating":"Classificazione a stelle","# star(s)":"{currentRating, plural, =1{# stella} other{# stelle}}"};